import { makeStyles } from '@material-ui/core/styles';

const useHeaderStyles = makeStyles(theme => ({
    header: {
        marginBottom: 0,
        paddingBottom: 0,
    },
}));

export default useHeaderStyles;
